import { api } from '../utils/request'

export const packageBooking = async (data) => {
    const resp = await api({
        endpoint: '/packageBooking',
        method: 'POST',
        data,
    })
    return resp
}

export const packageCity = async () => {
    const resp = await api({
        endpoint: '/packageCity',
        method: 'GET',

    })
    return resp
}

export const myProfile = async () => {
    const resp = await api({
        endpoint: '/user/me',
        method: 'GET',

    })
    return resp
}
export const myProfileUpdate = async (data) => {
    const resp = await api({
        endpoint: '/user/me',
        method: 'PUT',
        data

    })
    return resp
}

export const packageGet = async (query) => {
    const resp = await api({
        endpoint: '/package',
        method: 'GET',
        query,
    })
    return resp
}

/**
 * Get packages filtered by category (International, Domestic, Corporate)
 * @param {string} category - Package category to filter by
 */
export const getPackagesByCategory = async (category) => {
    const resp = await api({
        endpoint: '/package',
        method: 'GET',
        query: { packageMode: category }
    })
    return resp
}
export const packageGetId = async (id) => {
    const resp = await api({
        endpoint: `/package/${id}`,
        method: 'GET',

    })
    return resp
}

export const insurances = async (data) => {
    const resp = await api({
        endpoint: '/insuranceBooking',
        method: 'POST',
        data,
    })
    return resp
}


export const insuranceCountries = async (query) => {
    const resp = await api({
        endpoint: '/insuranceCountry',
        method: 'GET',
        query,
    })
    return resp
}
